/** Sentinel value for "Other (type city)" in the city select — not a real city name. */
export const CITY_SELECT_OTHER_VALUE = '__CRM_OTHER_CITY__';

/**
 * Map saved DB city + package list to UI mode and normalized city string for the form.
 * @param {string} savedCity
 * @param {Array<{ name: string }>} citiesFromPackage
 * @returns {{ mode: 'list' | 'other', cityForForm: string }}
 */
export function getCityFieldState(savedCity, citiesFromPackage) {
  const list = citiesFromPackage || [];
  const saved = String(savedCity || '').trim();
  if (!saved) {
    return { mode: 'list', cityForForm: '' };
  }
  if (list.length === 0) {
    return { mode: 'other', cityForForm: saved };
  }
  const found = list.find((c) => String(c.name || '').toLowerCase() === saved.toLowerCase());
  if (found) {
    return { mode: 'list', cityForForm: found.name };
  }
  return { mode: 'other', cityForForm: saved };
}
